import ProposedFormOfJudgments from './ProposedFormOfJudgments';

export default ProposedFormOfJudgments;
